import React from "react";
import sellexxText from "../assets/logos/sellexx_logo_text_only.svg";
import sellexxLogo from "../assets/logos/sellexx_logo.svg";
import { useNavigate } from "react-router-dom";

interface SellexxLogoProps {
  withText?: boolean;
  className?: string;
  mono?: boolean; 
}

const SellexxLogo: React.FC<SellexxLogoProps> = ({
  withText = true,
  className,
  mono = false,
}) => {
  const navigate = useNavigate();

  const handleLogoTap = () => {
    navigate(`/`);
  };

  // ✅ apply mono filter if true
  const monoClass = mono ? "invert brightness-0" : "";

  return withText ? (
    <button onClick={handleLogoTap} className="flex flex-row items-center">
      <img
        src={sellexxLogo}
        alt="Sellexx Logo"
        className={`${className} ${monoClass}`}
      />
      <img
        src={sellexxText}
        alt="Sellexx Logo Text"
        className={`ml-2 ${className} ${monoClass}`}
      />
    </button>
  ) : (
    <button onClick={handleLogoTap}>
      <img
        src={sellexxLogo}
        alt="Sellexx Logo"
        className={`${className} ${monoClass}`}
      />
    </button>
  );
};

export default SellexxLogo;
